import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import Alert from '@mui/material/Alert';
import { CircularProgress } from '@mui/material';
import React from 'react';
import { useMemo } from 'react';
import { SelectAnOrganizationPlaceholder } from 'apps/sigma2-ui/src/components/SelectAnOrganizationPlaceholder';
import { useLoadingObservationIds } from 'apps/sigma2-ui/src/lib/hooks/useLoadingObservationIds';

export const ObservationLoadError = () => {
  const language = useLanguage();

  return <Alert severity="error">{language.unableToLoadObservation()}</Alert>;
};

export const ObservationLoadingAndFailureIndicators = ({
  isLoadingStill,
  failedToLoadObservation,
  offset,
  isDashboardDetailPage,
}: {
  isLoadingStill: boolean;
  failedToLoadObservation: boolean;
  offset?: number;
  isDashboardDetailPage?: boolean;
}) => {
  const {
    organizationId: selectedOrganizationId,
    databaseId: selectedDatabaseId,
    databaseRevisionId: selectedDatabaseRevisionId,
  } = useLoadingObservationIds({
    isDashboardDetailPage,
  });

  const isReadyToLoadObservation = useMemo(() => {
    return (
      Boolean(selectedDatabaseRevisionId) &&
      Boolean(selectedDatabaseId) &&
      Boolean(selectedOrganizationId)
    );
  }, [selectedDatabaseRevisionId, selectedDatabaseId, selectedOrganizationId]);

  return (
    (isLoadingStill || failedToLoadObservation) && (
      <div
        className="flex flex-row justify-center items-center w-full"
        style={{
          height: `calc(100vh - ${offset ?? 0}px)`,
        }}
      >
        {isLoadingStill && isReadyToLoadObservation && (
          <CircularProgress
            className="text-secondary"
            color="inherit"
            size={96}
            thickness={8}
          />
        )}

        {!isReadyToLoadObservation && <SelectAnOrganizationPlaceholder />}

        {failedToLoadObservation && <ObservationLoadError />}
      </div>
    )
  );
};
